var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.5H15C14.4696 17.5 13.9609 17.7107 13.5858 18.0858C13.2107 18.4609 13 18.9696 13 19.5V27.5C13 28.0304 13.2107 28.5391 13.5858 28.9142C13.9609 29.2893 14.4696 29.5 15 29.5H25C25.5304 29.5 26.0391 29.2893 26.4142 28.9142C26.7893 28.5391 27 28.0304 27 27.5V19.5C27 18.9696 26.7893 18.4609 26.4142 18.0858C26.0391 17.7107 25.5304 17.5 25 17.5H24M20 22.5V11.5M20 11.5L17 14.5M20 11.5L23 14.5",
    stroke: "#4f4f4f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export_icon.3b39d30ee86d3788e74e30f4e9d06e2c.svg";
export { ForwardRef as ReactComponent };